import React from "react"
import { ContentCell } from "src/components/Grid"
import { PrimaryButton, SecondaryButton } from "@infotech/uikit-button"
import styles from "./styles.css"

const ButtonCell = ({ isOk, onClick, text, disabled = false }) => {
  const Component = isOk ? PrimaryButton : SecondaryButton
  return (
    <ContentCell className={styles[`c-box-half-padding`]}>
      <Component onClick={onClick} disabled={disabled}>
        {text}
      </Component>
    </ContentCell>
  )
}

export default ButtonCell
